import { getUser } from "../api/user";
import { IUser } from "../utils";
import { useQuery } from "@tanstack/react-query";


export default function useGetUser(): undefined | IUser {
  const {data: user} = useQuery(
    {
      queryKey: ['user'],
      queryFn:  async () => {
        return await getUser()
       }
    }
  )

  return user
}